import React from 'react';

interface DistanceDisplayProps {
  distanceKm: number;
  className?: string;
  textSize?: string;
}

export const DistanceDisplay: React.FC<DistanceDisplayProps> = ({
  distanceKm,
  className = "",
  textSize = "text-xs"
}) => {
  return (
    <div className={`${textSize} text-gray-500 ${className}`}>
      {distanceKm.toFixed(1)} km away
    </div>
  );
};

